import uajs from './ua';

export default function () {

  const ua = uajs();

  if (ua.Mobile || ua.Tablet) {
  } else {
    $('a, button, .p-cof__wbtn').addClass('is-hover');
  }

}
